import { InjectionToken } from '@angular/core';

import { StorageDriver } from './types';

export const STORAGE = new InjectionToken<StorageDriver>('STORAGE');
